// Advance Master Constants
export const ADVANCE_UPLOAD_REQUEST = 'ADVANCE_UPLOAD_REQUEST';
export const ADVANCE_UPLOAD_SUCCESS = 'ADVANCE_UPLOAD_SUCCESS';
export const ADVANCE_UPLOAD_FAIL = 'ADVANCE_UPLOAD_FAIL';
export const ADVANCE_UPLOAD_RESET = 'ADVANCE_UPLOAD_RESET';

export const ADVANCE_LIST_REQUEST = 'ADVANCE_LIST_REQUEST';
export const ADVANCE_LIST_SUCCESS = 'ADVANCE_LIST_SUCCESS';
export const ADVANCE_LIST_FAIL = 'ADVANCE_LIST_FAIL';

export const ADVANCE_UPDATE_REQUEST = 'ADVANCE_UPDATE_REQUEST';
export const ADVANCE_UPDATE_SUCCESS = 'ADVANCE_UPDATE_SUCCESS';
export const ADVANCE_UPDATE_FAIL = 'ADVANCE_UPDATE_FAIL';
export const ADVANCE_UPDATE_RESET = 'ADVANCE_UPDATE_RESET';

export const ADVANCE_DELETE_REQUEST = 'ADVANCE_DELETE_REQUEST';
export const ADVANCE_DELETE_SUCCESS = 'ADVANCE_DELETE_SUCCESS';
export const ADVANCE_DELETE_FAIL = 'ADVANCE_DELETE_FAIL';
export const ADVANCE_DELETE_RESET = 'ADVANCE_DELETE_RESET';

// Attendance Master Constants
export const ATTENDANCE_UPLOAD_REQUEST = 'ATTENDANCE_UPLOAD_REQUEST';
export const ATTENDANCE_UPLOAD_SUCCESS = 'ATTENDANCE_UPLOAD_SUCCESS';
export const ATTENDANCE_UPLOAD_FAIL = 'ATTENDANCE_UPLOAD_FAIL';
export const ATTENDANCE_UPLOAD_RESET = 'ATTENDANCE_UPLOAD_RESET';

export const ATTENDANCE_LIST_REQUEST = 'ATTENDANCE_LIST_REQUEST';
export const ATTENDANCE_LIST_SUCCESS = 'ATTENDANCE_LIST_SUCCESS';
export const ATTENDANCE_LIST_FAIL = 'ATTENDANCE_LIST_FAIL';

export const ATTENDANCE_UPDATE_REQUEST = 'ATTENDANCE_UPDATE_REQUEST';
export const ATTENDANCE_UPDATE_SUCCESS = 'ATTENDANCE_UPDATE_SUCCESS';
export const ATTENDANCE_UPDATE_FAIL = 'ATTENDANCE_UPDATE_FAIL';
export const ATTENDANCE_UPDATE_RESET = 'ATTENDANCE_UPDATE_RESET';

export const ATTENDANCE_DELETE_REQUEST = 'ATTENDANCE_DELETE_REQUEST';
export const ATTENDANCE_DELETE_SUCCESS = 'ATTENDANCE_DELETE_SUCCESS';
export const ATTENDANCE_DELETE_FAIL = 'ATTENDANCE_DELETE_FAIL';
export const ATTENDANCE_DELETE_RESET = 'ATTENDANCE_DELETE_RESET';

export const ATTENDANCE_STATS_REQUEST = 'ATTENDANCE_STATS_REQUEST';
export const ATTENDANCE_STATS_SUCCESS = 'ATTENDANCE_STATS_SUCCESS';
export const ATTENDANCE_STATS_FAIL = 'ATTENDANCE_STATS_FAIL';

// Bonus Master Constants
export const BONUS_UPLOAD_REQUEST = 'BONUS_UPLOAD_REQUEST';
export const BONUS_UPLOAD_SUCCESS = 'BONUS_UPLOAD_SUCCESS';
export const BONUS_UPLOAD_FAIL = 'BONUS_UPLOAD_FAIL';
export const BONUS_UPLOAD_RESET = 'BONUS_UPLOAD_RESET';

export const BONUS_LIST_REQUEST = 'BONUS_LIST_REQUEST';
export const BONUS_LIST_SUCCESS = 'BONUS_LIST_SUCCESS';
export const BONUS_LIST_FAIL = 'BONUS_LIST_FAIL';

export const BONUS_UPDATE_REQUEST = 'BONUS_UPDATE_REQUEST';
export const BONUS_UPDATE_SUCCESS = 'BONUS_UPDATE_SUCCESS';
export const BONUS_UPDATE_FAIL = 'BONUS_UPDATE_FAIL';
export const BONUS_UPDATE_RESET = 'BONUS_UPDATE_RESET';

export const BONUS_DELETE_REQUEST = 'BONUS_DELETE_REQUEST';
export const BONUS_DELETE_SUCCESS = 'BONUS_DELETE_SUCCESS';
export const BONUS_DELETE_FAIL = 'BONUS_DELETE_FAIL';
export const BONUS_DELETE_RESET = 'BONUS_DELETE_RESET';
